import { ref } from "vue";

interface UseHoverMenuOptions {
  delay?: number;
}

export function useHoverMenu(options: UseHoverMenuOptions = {}) {
  const delay = options.delay ?? 150;
  const activeId = ref<string | null>(null);
  let hoverTimer: ReturnType<typeof setTimeout> | null = null;

  function handleHoverEnter(id: string) {
    if (hoverTimer) {
      clearTimeout(hoverTimer);
      hoverTimer = null;
    }
    activeId.value = id;
  }

  function handleHoverLeave(id: string) {
    if (hoverTimer) {
      clearTimeout(hoverTimer);
    }
    hoverTimer = setTimeout(() => {
      if (activeId.value === id) {
        activeId.value = null;
      }
    }, delay);
  }

  function isActive(id: string): boolean {
    return activeId.value === id;
  }

  return { activeId, handleHoverEnter, handleHoverLeave, isActive };
}
